<template>
  <article class="article-shell light-player-shell">
    <header v-if="currentVideo" class="article-hero article-hero-compact light-player-hero">
      <div class="article-hero-copy">
        <div class="article-hero-top">
          <span class="article-eyebrow">{{ currentVideo.categoryTitle }} / 视频</span>
          <RouterLink class="article-back-link" to="/light-videos">
            返回 ↩
          </RouterLink>
        </div>
        <h1>{{ currentVideo.title }}</h1>
        <p v-if="currentVideo.heroSummary || currentVideo.summary">
          {{ currentVideo.heroSummary || currentVideo.summary }}
        </p>
        <div class="article-meta">
          <span>{{ currentVideo.categoryTitle }}</span>
          <span>{{ currentVideo.date }}</span>
          <span>{{ currentVideo.duration || "视频作品" }}</span>
        </div>
      </div>
    </header>

    <section class="article-reader-card light-player-card">
      <template v-if="currentVideo">
        <div v-if="embedUrl" class="light-player-frame">
          <iframe
            :src="embedUrl"
            :title="currentVideo.title"
            loading="lazy"
            allow="fullscreen; autoplay; encrypted-media; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>

        <div v-else class="notes-empty-state">
          <h2>这个链接暂时不能内嵌播放</h2>
          <p>请确认后台填写的是 B 站视频详情页链接，比如包含 BV 号或 av 号的地址。</p>
        </div>

        <div class="light-player-info">
          <p v-if="currentVideo.summary">{{ currentVideo.summary }}</p>
          <a
            v-if="currentVideo.sourceUrl"
            :href="currentVideo.sourceUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            在 B 站打开原视频
          </a>
        </div>
      </template>

      <div v-else class="notes-empty-state">
        <h2>还没有可播放的视频</h2>
        <p>请先在后台的光影音域模块中新增视频。</p>
      </div>
    </section>
  </article>
</template>

<script setup>
import { computed, watchEffect } from "vue";
import { RouterLink, useRoute } from "vue-router";
import { useContentStore } from "@/store/contentStore";

const route = useRoute();
const { lightVideos, getBilibiliEmbedUrl } = useContentStore();

const currentVideo = computed(() => {
  const matched = lightVideos.value.find((item) => item.slug === route.params.slug);
  return matched || lightVideos.value[0] || null;
});

const embedUrl = computed(() =>
  currentVideo.value
    ? currentVideo.value.embedUrl ||
      getBilibiliEmbedUrl(currentVideo.value.sourceUrl, {
        page: currentVideo.value.page,
      })
    : ""
);

watchEffect(() => {
  document.title = currentVideo.value
    ? `圣域空间 | ${currentVideo.value.title}`
    : "圣域空间 | 光影音域";
});
</script>
